<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-prompt
          class="invite-user-prompt"
          title="Invite User"
          @cancel="resetForm"
          @accept="acceptAlert"
          @close="resetForm"
          :is-valid="validForm"
          :active.sync="activeInviteUserPrompt"
        >
          <div class="invitee-form">
            <vs-row class="mb-base">
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Email<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="Email"
                  data-vv-validate-on="blur"
                  v-validate="'required|email'"
                  v-model="localData.email"
                  @input="userExists()"
                />
                <span v-if="userAlreadyExists" class="text-danger text-sm"
                  >User/Email already exists</span
                >
                <span class="text-danger text-sm">{{
                  errors.first("Email")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>First Name<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="First Name"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.firstName"
                />
                <span class="text-danger text-sm">{{
                  errors.first("First Name")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Last Name<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="Last Name"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.lastName"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Last Name")
                }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mb-base">
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label
                  >Primary Language<span class="text-danger">*</span></label
                >
                <!-- <vs-input
                class="w-full invitee-form-input"
                name="Language"
                placeholder="Enter Language"
                data-vv-validate-on="blur"
                v-validate="'required'"
                v-model="localData.language"
              /> -->
                <v-select
                  class="w-full invitee-form-input"
                  name="Primary Language"
                  v-model="localData.primaryLanguage"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :options="languageOptions"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Primary Language")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label
                  >Current Location<span class="text-danger">*</span></label
                >
                <!-- <vs-input
                class="w-full invitee-form-input"
                name="Country"
                data-vv-validate-on="blur"
                v-validate="'required'"
                v-model="localData.country"
              /> -->
                <v-select
                  class="w-full invitee-form-input"
                  name="Current Location"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.currentLocation"
                  :options="countryOptions"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Current Location")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Date of Birth<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="Date of Birth"
                  type="date"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.dob"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Date of Birth")
                }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mb-base">
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Department<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="Department"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.department"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Department")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Role Title<span class="text-danger">*</span></label>
                <vs-input
                  class="w-full invitee-form-input"
                  name="Role Title"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.roleTitle"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Role Title")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Level<span class="text-danger">*</span></label>
                <!-- <vs-input
                class="w-full invitee-form-input"
                name="Level"
                data-vv-validate-on="blur"
                v-validate="'required'"
                v-model="localData.level"
              /> -->
                <v-select
                  class="w-full invitee-form-input"
                  name="Level"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.level"
                  :options="levelOptions"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Level")
                }}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mb-base">
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label
                  >Number of Direct Reports<span class="text-danger"
                    >*</span
                  ></label
                >
                <vs-input
                  class="w-full invitee-form-input"
                  type="number"
                  name="Number of Direct Reports"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.numberOfDirectReports"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Number of Direct Reports")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Performance<span class="text-danger">*</span></label>
                <!-- <vs-input
                class="w-full invitee-form-input"
                name="Performance"
                placeholder="Enter Performance"
                data-vv-validate-on="blur"
                v-validate="'required'"
                v-model="localData.performance"
              /> -->
                <v-select
                  class="w-full invitee-form-input"
                  name="Performance"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.performance"
                  :options="performanceOptions"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Performance")
                }}</span>
              </vs-col>
              <vs-col class="px-2" vs-w="4" vs-xs="12">
                <label>Potential<span class="text-danger">*</span></label>
                <!-- <vs-input
                class="w-full invitee-form-input"
                name="Potential"
                placeholder="Enter Potential"
                data-vv-validate-on="blur"
                v-validate="'required'"
                v-model="localData.potential"
              /> -->
                <v-select
                  class="w-full invitee-form-input"
                  name="Potential"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  v-model="localData.potential"
                  :options="potentialOptions"
                />
                <span class="text-danger text-sm">{{
                  errors.first("Potential")
                }}</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-prompt>
        <vs-button
          class="invite-user-btn"
          @click.stop="activeInviteUserPrompt = true"
          >Invite User</vs-button
        >
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="(i, index) in alexUsers"
        :key="index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base"
      >
        <user-card :alexUserdata="i" />
      </div>
    </div>
  </div>
</template>

<script>
import UserCard from "./components/UserCard.vue";
import allLanguages from "@/assets/data/all-languages.js";
import allCountries from "@/assets/data/country-codes.js";
import vSelect from "vue-select";

export default {
  data() {
    return {
      activeInviteUserPrompt: false,
      localData: {},
      languageOptions: allLanguages,
      countryOptions: allCountries,
      performanceOptions: [
        { key: 0, label: "Limited" },
        { key: 1, label: "Medium" },
        { key: 2, label: "High" },
      ],
      potentialOptions: [
        { key: 0, label: "Limited" },
        { key: 1, label: "Medium" },
        { key: 2, label: "High" },
      ],
      levelOptions: [
        { key: 0, label: "Professional" },
        { key: 1, label: "People Coach" },
        { key: 2, label: "Process Integrator" },
      ],
      userAlreadyExists: false,
    };
  },
  components: { vSelect, UserCard },
  computed: {
    alexUsers() {
      return this.$store.state.organization.alexUsers;
    },
    validForm() {
      let validEmail = this.localData.email;
      let validFirstName = this.localData.firstName;
      let validLastName = this.localData.lastName;
      let validPrimaryLanguage = this.localData.primaryLanguage;
      let validCurrentLocation = this.localData.currentLocation;
      let validDateOfBirth = this.localData.dob;
      let validRoleTitle = this.localData.roleTitle;
      let validLevel = this.localData.level;
      let validNumOfDirRep = this.localData.numberOfDirectReports;
      let validDepartment = this.localData.department;
      let validPerformance = this.localData.performance;
      let validPotential = this.localData.potential;
      // console.log(this.$validator.errors.items.length);
      if (
        this.$validator.errors.items.length ||
        !validEmail ||
        this.userAlreadyExists ||
        !validFirstName ||
        !validLastName ||
        !validPrimaryLanguage ||
        !validCurrentLocation ||
        !validDateOfBirth ||
        !validRoleTitle ||
        !validLevel ||
        !validNumOfDirRep ||
        !validDepartment ||
        !validPerformance ||
        !validPotential
      )
        return false;
      return true;
    },
  },
  methods: {
    userExists() {
      // console.log(this.localData.email);
      this.$store
        .dispatch("organization/fetchUserByEmail", {
          email: this.localData.email,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.total > 0) {
            this.userAlreadyExists = true;
          } else {
            this.userAlreadyExists = false;
          }
        });
    },
    resetForm() {
      this.localData = {};
    },
    acceptAlert() {
      this.$vs.loading();

      this.localData.password = Math.random().toString(36).substring(15);

      const userObj = {
        email: this.localData.email,
        password: this.localData.password,
        firstName: this.localData.firstName,
        lastName: this.localData.lastName,
        dob: this.localData.dob,
      };

      const alexObj = {
        email: this.localData.email,
        organizationId: "607aa2cce7a4360958e1538b",
        primaryLanguage: this.localData.primaryLanguage,
        currentLocation: this.localData.currentLocation,
        roleTitle: this.localData.roleTitle,
        level: this.localData.level,
        numberOfDirectReports: this.localData.numberOfDirectReports,
        performance: this.localData.performance,
        potential: this.localData.potential,
        status: false,
      };

      this.$store
        .dispatch("organization/inviteUserOnAlex", { userObj, alexObj })
        .then((res) => {
          this.$vs.notify({
            title: "Alex invitation sent successfully",
            text: "Alex invitation sent successfully",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });

          this.resetForm();

          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Failed to send Alex invitation",
            text: "Failed to send Alex invitation",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            fixed: false,
          });

          this.$vs.loading.close();

          throw err;
        });
    },
  },
  created() {
    this.$store.dispatch("organization/fetchAllUsersInAlex").catch((err) => {
      throw err;
    });
  },
};
</script>

<style scoped>
.invite-user-btn {
  border-radius: 6px;
}

.invite-user-prompt >>> .vs-dialog {
  width: 900px;
  max-width: 900px;
  height: auto;
}

.invitee-form .invitee-form-input >>> .vs-con-input .vs-input--input {
  background: #f4f6fb !important;
  /* Solitude */
  border: 1px solid #dfe3eb !important;
  box-sizing: border-box !important;
  border-radius: 6px !important;
}

.vs--searchable >>> .vs__dropdown-toggle {
  background: #f4f6fb !important;
  /* Solitude */
  border: 1px solid #dfe3eb !important;
  border-radius: 6px !important;
}
</style>
